var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 21c-.2954 0-.586-.0891-.8438-.2625-1.7625-1.1953-4.32187-3.0469-6.15937-5.2875-1.875-2.2828-2.775-4.6312-2.74688-7.17187C2.27828 5.36719 4.61734 3 7.45796 3 9.71265 3 11.208 4.38281 12.0002 5.39062 12.7923 4.38281 14.2877 3 16.5423 3c2.8407 0 5.175 2.36719 5.2079 5.27813.0234 2.54067-.8719 4.88907-2.7469 7.17187-1.8375 2.2406-4.3969 4.0922-6.1594 5.2875-.2578.1781-.5484.2625-.8437.2625Z",
    fill: "#667E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart_filled.01b46f2c9da5f11dfb33d9f77ba1e8f2.svg";
export { ForwardRef as ReactComponent };